import { EventType, IEvent } from '~/Models/DTO/Event.model';

export const groupEvents = ({ events }: { events: IEvent[] }) =>
  events?.reduce(
    (eventGroups, event) => {
      if (event.type === EventType.FREE_TRAINING) {
        eventGroups.fullDayActivity.push(event);
      } else {
        eventGroups.usualEvents.push(event);
      }
      return eventGroups;
    },
    { fullDayActivity: [] as IEvent[], usualEvents: [] as IEvent[] },
  );
